import React from 'react'
import locale from 'live/init/global-locale'
import i18n from 'live/services/i18n'
import widgetService from 'live/services/widgets'
import { reactWidgetWrapper } from 'live/widgets/decorators/react'

import { enUS, ptBR } from './i18n'
import { themeWrapper, CONFIGURATION } from './utils'
import { reducer } from './WellOperationsNavigation'
import { withSuspenseWrapper } from '../../SuspenseWrapper'

// const WrapperWellOperationsNavigation = withSuspenseWrapper(
//     React.lazy(() => import('./WellOperationsNavigation/WellOperationsNavigation'))
// )

import WrapperWellOperationsNavigation from './WellOperationsNavigation/WellOperationsNavigation'

const localeFiles = {
    pt_br: ptBR,
    en_us: enUS
}

i18n.add(localeFiles[locale])

widgetService.register({
    type: CONFIGURATION.type,
    name: CONFIGURATION.name,
    description: CONFIGURATION.description,
    config: CONFIGURATION.cfg,
    policies: {
        handleOwnMissingData: true
    },
    impl: reactWidgetWrapper(themeWrapper(WrapperWellOperationsNavigation), reducer)
})
